<template>
  <div>
    <iframe
      id='myIframe'
      :src="'http://oldinfo.andymark.com/' + $route.params.route"
      class="inline-page"
    />
  </div>
</template>

<style scoped>
  .inline-page {
    margin: 0;
    padding: 0;
    border: none;
    overflow: visible;
    width: 100%;
    height: 2000px;
  }
</style>

<script type="text/javascript">
  var callback = function(){
    var loc = window.location.toString(),
      params = loc.split('?')[1];
    iframe = document.getElementById('myIframe');
    if(iframe) {
      iframe.src = iframe.src + '?' + params;
    }
  };

  if (
      document.readyState === "complete" ||
      (document.readyState !== "loading" && !document.documentElement.doScroll)
  ) {
    callback();
  } else {
    document.addEventListener("DOMContentLoaded", callback);
  }
</script>



// WEBPACK FOOTER //
// src/components/IFramedRoutes.vue